import React, { useContext, useMemo } from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import { useParams } from 'react-router-dom'
import { initiativeUrl } from 'config/constants/urls'
import ContainerBlock from 'src/apps/CustomApp/blocks/Container'
import LayoutContainer from 'src/apps/CustomApp/components/LayoutContainer'
import Title from 'src/apps/CustomApp/components/Title'
import Titlebar from 'src/apps/CustomApp/components/Titlebar'
import InitiativeCreateControl from 'src/apps/Initiative/components/CreateControl'
import InitiativeList from 'src/apps/Initiative/components/List'
import { useOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import ResourceListItemCard from '~/components/ListItemCard'

const ResourcesHome = () => {
   const { initiativeTypeSlug } = useParams()
   const theme = useContext(ThemeContext)
   const { organization } = useOrganization()
   const resourceInitiativeTypes = organization.initiativeTypes
      .filter(t => t.enabled && t.class === 'resource')

   // If there is an initiativeTypeSlug, show only resources of that type
   // Otherwise, we assume it is a full Events app and show all resources of
   // any initiative type
   const initiativeTypes = useMemo(() => {
      if (initiativeTypeSlug) {
         const initiativeType = organization.initiativeTypes
            .find(type => type.slug === initiativeTypeSlug)

         if (initiativeType) {
            return [initiativeType]
         }
      }

      return organization.initiativeTypes
         .filter(type => type.enabled && type.class === 'resource')
   }, [organization.initiativeTypes, initiativeTypeSlug])

   const initiativeTypeIds = initiativeTypes.map(type => type.id)
   const appTitle = initiativeTypeSlug && initiativeTypes[0]
      ? initiativeTypes[0].namePlural
      : 'Resources'

   const resourcesFilter = useMemo(() => ({
      archived: 'exclude',
      drafts: 'include',
      sortBy: 'dateLastUpdated',
      typeIds: initiativeTypeIds,
      limit: 20
   }), [initiativeTypeIds])

   return (
      <LayoutContainer>
         <ContainerBlock>
            <Titlebar>
               <Title>{appTitle}</Title>
               <InitiativeCreateControl initiativeTypes={resourceInitiativeTypes} />
            </Titlebar>
            <View marginTop="20px[a-d] 30px[e-f]">
               <Grid
                  columns="1[a] 2[b] 3[c-e] 4[f]"
                  spacing="15px[a-d] 20px[e-f]">
                  <InitiativeList
                     emptyContent={(
                        <GridCell>
                           <View width="100%" padding="0px 0px">
                              <Text size="2" color="#aaa">No items to show</Text>
                           </View>
                        </GridCell>
                     )}
                     filter={resourcesFilter}>
                     {initiativeList => initiativeList.items.map(initiative => (
                        <GridCell key={initiative.id}>
                           <ResourceListItemCard
                              coverMedia={initiative.coverMedia}
                              dateAdded={initiative.dateAdded}
                              linkTo={initiativeUrl(initiative)}
                              name={initiative.name}
                              privacy={initiative.privacy}
                              subtitle={initiative.subtitle}
                              summary={initiative.body.summary}
                              textColor={theme.tmpNavTextColor}
                           />
                        </GridCell>
                     ))}
                  </InitiativeList>
               </Grid>
            </View>
         </ContainerBlock>
      </LayoutContainer>
   )
}

export default ResourcesHome
